import styled from "styled-components"
import { device } from "../styles/stylesConfig"
import { memo, useContext, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { allAnimations } from "../effects/Observers"
import { ThemeContext } from "../contexts/theme/ThemeContext"

const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    z-index: 2;
    background-color: #000;
`

const ContentContainer = styled.div`
    width: 70%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;

    @media ${device.lg} {
        width: 90%;
        flex-direction: column;
        gap: 10vh
    }

    @media ${device.sm} {
        gap: 10vh
    }
`

const DataContainer = styled.div`
    width: 100%;
    height: 400px;
    display: grid;
    grid-template-columns: 1fr;
    gap: 50px;
    place-items: center;

    @media ${device.lg} {
        height: auto;
        grid-template-columns: 1fr 1fr;
        gap: 0px;
    }
    
`

const InfoDiv = styled.div`
    position: absolute;
    bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
`

const Info = styled.p`
    width: 100%;
    color: white;
    font-size: 16px;
    text-align: center;

    @media ${device.md} {
        font-size: 14px;
    }

    @media ${device.sm} {
        font-size: 12px;
    }

`

const ImageInfo = styled.img`
    width: 30px;
    height: auto;
    object-fit: contain;
    rotate: 90deg;

    @media ${device.md} {
        width: 25px;
    }

    @media ${device.sm} {
        width: 20px;
    }

`

const FirstImage = styled.img`
    width: 400px;
    height: auto;
    object-fit: contain;

    @media ${device.lg} {
        width: 320px;
    }

    @media ${device.md} {
        width: 250px;
    }

    @media ${device.sm} {
        width: 150px;
    }

`

const SecondImage = styled.img`
    width: 250px;
    height: auto;
    object-fit: contain;

    @media ${device.lg} {
        width: 200px;
    }

    @media ${device.md} {
        width: 150px;
    }

    @media ${device.sm} {
        width: 100px;
    }

`

const Title = styled.h1`
    width: 100%;
    font-size: 70px;
    text-transform: uppercase;
    color: white;
    text-align: center;
    font-weight: bold;

    @media ${device.md} {
        font-size: 50px;
    }

    @media ${device.sm} {
        font-size: 30px;
    }

`

const GlassProductIntroComponent = ({ title, slice }: any) => {

    const location = useLocation();

    useEffect(() => {

        allAnimations();

        return () => {
            allAnimations()
        };

    }, [location.pathname])

    return (

        <Container>

            <ContentContainer>

                <Title className="utils__fade-in-fast-top">{title}</Title>

                <DataContainer>

                    <FirstImage src={require(`../images/aluviher-blanco.png`)} alt={'Logo Aluviher'} className="utils__fade-in-fast-top" />

                    <SecondImage src={require(`../images/disvial-blanco.webp`)} alt={'Logo Disvial'} className="utils__fade-in-fast-top" />

                </DataContainer>


            </ContentContainer>

            <InfoDiv className="utils__fade-in-fast-top">

                <Info dangerouslySetInnerHTML={{ __html: slice }} />

                <ImageInfo src={require(`../images/flecha.png`)} alt={'Flecha'} />

            </InfoDiv>


        </Container>

    )
}

const GlassProductIntro = memo(GlassProductIntroComponent);

export default GlassProductIntro;
